import { isNotEmptyString } from '@vy/utils';
import { usePlansOverviews } from '../../../../../../hooks/requests/use-plans-overview/use-plans-overviews';

type UseSelectPlanTemplateDialogDataParams = {
  search: string;
  page: number;
  pageSize: number;
};

export function useSelectPlanTemplateDialogData({
  search,
  page,
  pageSize,
}: UseSelectPlanTemplateDialogDataParams) {
  const trimmed = search.trim();

  const { data, isFetching } = usePlansOverviews({
    page,
    pageSize,
    search: isNotEmptyString(trimmed) ? trimmed : undefined,
  });

  return {
    templates: data?.plansOverviews ?? [],
    itemsCount: data?.countedFilteredPlansOverviews ?? 0,
    isLoading: isFetching,
  };
}
